import React from 'react';
import Button from '../ui/Button';
import { motion } from 'framer-motion';
import {
  FaImage,
  FaTags,
  FaGraduationCap,
  FaUniversity
} from 'react-icons/fa';
import styles from './Step4ProfileCustomization.module.css';
import MultiSelectTopics from './../MultiSelectTopics/MultiSelectTopics';
import { useTranslation } from 'react-i18next';

const stepVariants = {
  hidden: { opacity: 0, x: 100 },
  visible: { opacity: 1, x: 0 },
  exit: { opacity: 0, x: -100 },
};


const Step4ProfileCustomization = ({ nextStep, prevStep, setFormData, formData }) => {
    const { t } = useTranslation();
	

const affiliationTypes = [
	{ label: t('profile.affiliationTypes.highschool'), value: 'highschool' },
	{ label: t('profile.affiliationTypes.university'), value: 'university' },
	{ label: t('profile.affiliationTypes.debateclub'), value: 'debateclub' },
	{ label: t('profile.affiliationTypes.lawschool'), value: 'lawschool' },
	{ label: t('profile.affiliationTypes.mediaorg'), value: 'mediaorg' },
	{ label: t('profile.affiliationTypes.nonprofit'), value: 'nonprofit' },
	{ label: t('profile.affiliationTypes.government'), value: 'government' },
	{ label: t('profile.affiliationTypes.company'), value: 'company' }
];

  const handleChange = e => {
	const { name, value } = e.target;
    setFormData(prev => ({ ...prev, [name]: value }));
  };

  const handleOptionChange = (name, value) => {
    //console.log(e);
	//const { name, value } = e.target;
    setFormData(prev => ({ ...prev, [name]: value }));
  };

  const handleFileChange = e => {
    const file = e.target.files[0];
    if (file) {
      setFormData(prev => ({ ...prev, profilePicture: file }));
    }
  };



  const uploadLogo = e => {
   const file = e.target.files[0];
    if (file) {
      setFormData(prev => ({ ...prev, affiliationLogoFile: file }));
    }
  };

  return (
    <>
      <h2 className={styles.stepTitle}>Customize Your Profile</h2>

      {/* Profile Picture */}
      <div className={styles.inputGroup}>
        <label htmlFor="profilePicture">
          <FaImage className={styles.icon} />
          Profile Picture
        </label>
        <input
          type="file"
          id="profilePicture"
          accept="image/*"
          className={styles.inputField}
          onChange={handleFileChange}
        />
        <small className={styles.helperText}>This helps others recognize you in debates. Optional.</small>
      </div>

      {/* Topics of Interest */}
      <div className={styles.inputGroup}>
        <label htmlFor="topics">
          <FaTags className={styles.icon} />
          Debate Topics of Interest
        </label>
		<MultiSelectTopics  className={styles.inputField} id="topics" name="topics" value={formData.topics || []} onChange={(topics) => handleOptionChange("topics", topics)}  required /> 

        <small className={styles.helperText}>What topics do you enjoy debating?</small>
      </div>

      {/* Experience Level */}
      <div className={styles.inputGroup}>
        <label htmlFor="experience">
          <FaGraduationCap className={styles.icon} />
          Experience Level
        </label>
        <select
          id="experience"
          name="experience"
          className={styles.inputField}
          value={formData.experience || ''}
          onChange={handleChange}
        >
          <option value="">Select experience (Optional)</option>
          <option value="Novice">Novice</option>
          <option value="Intermediate">Intermediate</option>
          <option value="Expert">Expert</option>
        </select>
        <small className={styles.helperText}>Let others know your experience level.</small>
      </div>

      {/* Affiliation */}
      <div className={styles.inputGroup}>
        <label htmlFor="affiliation">
          <FaUniversity className={styles.icon} />
          Affiliation
        </label>
		<select  className={styles.inputField} id="affiliation" name="affiliation"  placeholder="School, Organization, etc." value={formData.affiliation || ''} onChange={handleChange}>
		  <option value="">{t('profile.select')}</option>
		  {affiliationTypes.map(item => <option key={item.value} value={item.value}>{item.label}</option>)}
		</select>
		
	  <label>{t('profile.affiliationName')}</label>
	  <input  className={styles.inputField} name="affiliationName" value={formData.affiliationName || ''} onChange={handleChange} />
	  <label>{t('profile.affiliationLogo')}</label>
	  <input  className={styles.inputField} type="file" accept="image/*" onChange={uploadLogo} />
			  
        <small className={styles.helperText}>Optional. Shown on your public profile.</small>
      </div>

      <div className={styles.navbuts}>
        <Button variant="secondary" className={styles.prevButton} onClick={prevStep}>Back</Button>
        <Button variant="primary" className={styles.nextButton} onClick={nextStep}>Next</Button>
      </div>
    </>
  );
};

export default Step4ProfileCustomization;

